import { render, staticRenderFns } from "./primerOther.vue?vue&type=template&id=055b2f02&scoped=true"
import script from "./primerOther.vue?vue&type=script&lang=js"
export * from "./primerOther.vue?vue&type=script&lang=js"
import style0 from "./primerOther.vue?vue&type=style&index=0&id=055b2f02&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b2f02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055b2f02')) {
      api.createRecord('055b2f02', component.options)
    } else {
      api.reload('055b2f02', component.options)
    }
    module.hot.accept("./primerOther.vue?vue&type=template&id=055b2f02&scoped=true", function () {
      api.rerender('055b2f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/pay/primerOther.vue"
export default component.exports